import { Modules } from "./module";
export class DeviceInterfaceKnobAdapter {
    #context;
    #box;
    constructor(context, box) {
        this.#context = context;
        this.#box = box;
    }
    get box() { return this.#box; }
    get uuid() { return this.#box.address.uuid; }
    get address() { return this.#box.address; }
    get moduleAdapter() {
        return Modules.adapterFor(this.#context.boxAdapters, this.#parameterTarget.box);
    }
    get parameterAdapter() {
        return this.moduleAdapter.parameters.parameterAt(this.#parameterTarget.address);
    }
    get #parameterTarget() {
        return this.#box.parameter.targetVertex.unwrap("Parameter not assigned");
    }
    terminate() {
    }
}
